import ActivityFeedItem from './ActivityFeedItem';
import type { AgentAction } from '../types';

interface ActivityFeedProps {
  actions: AgentAction[];
  loading?: boolean;
  error?: boolean;
  onSelect: (action: AgentAction) => void;
}

export default function ActivityFeed({ actions, loading, error, onSelect }: ActivityFeedProps) {
  if (loading) {
    return <div className="text-sm text-gray-500 py-8 text-center">Loading activity…</div>;
  }

  if (error) {
    return <div className="text-sm text-red-600 py-8 text-center">Failed to load activity feed.</div>;
  }

  if (!actions.length) {
    return (
      <div className="text-sm text-gray-500 py-12 text-center">
        No agent activity in this time range.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {actions.map((action) => (
        <ActivityFeedItem key={action.id} action={action} onClick={() => onSelect(action)} />
      ))}
    </div>
  );
}
